/*
 *  International Message
 *
 *
 *  Version:
 *    1.0.0 - 2020/10/14
 */

import { register, ShopifySection } from './../ShopifySection';

export const CONTAINER_SELECTOR = '[data-international-message]';
export const POPUP_SELECTOR = '[data-international-message-title]';
export const CLASS_POPUP_OPEN = 'is-int-msg-popup-open';

export class InternationalMessage extends ShopifySection {
  constructor(container) {
    super(container);
    this.popupTargets = $('html,body');
    this.messageContainer = container.find(POPUP_SELECTOR);
    this.messageContainer.on('click touch', 'a[href=\'#\']', e => this.onOpenClick(e));
  }

  onOpenClick(e) {
    e.preventDefault(), e.stopPropagation();
    $('html,body').addClass(CLASS_POPUP_OPEN);
  }

  
}

register(CONTAINER_SELECTOR, InternationalMessage);
